import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./Redux/Store";
import { initFaro, pushError } from "./monitoring/faro";
import "./index.css";
import "./assets/css/theme.css";
import "bootstrap-daterangepicker/daterangepicker.css";

import App from "./App.jsx";

// Initialise Grafana Faro before rendering — must be the first call.
// No-op when VITE_GRAFANA_FARO_URL is not set (e.g. local dev without monitoring).
initFaro();

// Catch unhandled promise rejections not caught by Faro's ErrorsInstrumentation
// (e.g. rejections inside event handlers that Faro cannot intercept).
window.addEventListener("unhandledrejection", (event) => {
  pushError(event.reason ?? new Error("Unhandled promise rejection"), {
    source: "unhandledrejection",
  });
});

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </StrictMode>
);
